import React, {useState, useRef} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper';
import {Title, TitleLevel, TitleSize} from '../Title';

import './ReviewsSwiper.scss';

const ReviewsSwiper = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const swiperRef = useRef(null);

  return (
    <div className="reviews-swiper__wrapper">
      <span className="reviews-swiper__counter">{currentIndex}/3</span>

      <Swiper
        ref={swiperRef}
        modules={[Navigation]}
        pagination={{
          type: 'fraction',
        }}
        spaceBetween={4}
        slidesPerView={3}
        onSlideChange={swiper => setCurrentIndex(swiper.activeIndex + 1)}
        className="reviews-swiper"
        breakpoints={{
          1201: {
            slidesPerView: 3,
            spaceBetween: 4,
          },
          601: {
            slidesPerView: 2,
            spaceBetween: 4,
          },
          0: {
            slidesPerView: 1,
            spaceBetween: 4,
          },
        }}
      >
        <SwiperSlide className="reviews-swiper__slide">
          <div className="reviews-swiper__slide-header">
            <Title
              className="reviews-swiper__slide-title"
              level={TitleLevel.H3}
              size={TitleSize.H3}
            >
              Борис
            </Title>
            <span className="reviews-swiper__slide-date">Январь 2021</span>
          </div>

          <div className="reviews-swiper__slide-stars" />

          <p className="reviews-swiper__slide-text">
            Я&nbsp;остался доволен. Ребята профессионалы, составили смету
            с&nbsp;небольшими обоснованными поправками в&nbsp;процессе работ.
            Качество мне понравилось, цена устроила. Чистота и&nbsp;порядок
            соблюдались. Рекомендую.
          </p>

          <span className="reviews-swiper__slide-service">Санузел</span>

          <span className="reviews-swiper__slide-price">
            161&nbsp;000&nbsp;₽
          </span>
        </SwiperSlide>

        <SwiperSlide className="reviews-swiper__slide">
          <div className="reviews-swiper__slide-header">
            <Title
              className="reviews-swiper__slide-title"
              level={TitleLevel.H3}
              size={TitleSize.H3}
            >
              Артём
            </Title>
            <span className="reviews-swiper__slide-date">Июнь 2022</span>
          </div>

          <div className="reviews-swiper__slide-stars"></div>

          <p className="reviews-swiper__slide-text">
            Мастер чётко составил смету, назвал сроки первых работ, после этого
            часто делал даже быстрее, чем говорил. Если что-то
            не&nbsp;нравилось, шёл на&nbsp;встречу и&nbsp;доделывал, даже если
            это была моя ошибка. Рекомендую.
          </p>

          <span className="reviews-swiper__slide-service">Ванная комната</span>

          <span className="reviews-swiper__slide-price">
            173&nbsp;028&nbsp;₽
          </span>
        </SwiperSlide>

        <SwiperSlide className="reviews-swiper__slide">
          <div className="reviews-swiper__slide-header">
            <Title
              className="reviews-swiper__slide-title"
              level={TitleLevel.H3}
              size={TitleSize.H3}
            >
              Ольга
            </Title>
            <span className="reviews-swiper__slide-date">Декабрь 2022</span>
          </div>

          <div className="reviews-swiper__slide-stars"></div>

          <p className="reviews-swiper__slide-text">
            Всё очень хорошо сделано. Десять баллов. Мастер понравился.
            Аккуратно и&nbsp;бережно относился к&nbsp;строительным материалам.
            По&nbsp;чтоимости услуг договорённости соблюдены. После оформления
            заказа пришлось подождать начала работ, но&nbsp;это не&nbsp;было для
            нас проблемой.
          </p>

          <span className="reviews-swiper__slide-service">
            Совмещенный санузел
          </span>

          <span className="reviews-swiper__slide-price">
            112&nbsp;500&nbsp;₽
          </span>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default ReviewsSwiper;
